import React from "react"
import Layout from "./index"

export const wrapPageElement = ({ element }) => <Layout>{element}</Layout>
